import CategorySwiper from '@components/category-swiper/CategorySwiper';
import {
    CategoriesFragment,
    ContentBlockFragment,
    DiscoverMainContentFolderFragment,
    KolSectionItemFragment,
} from '@graphqlTypes/sitecore';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import {
    isTimeFrame,
    contentArr,
    isShareUrl,
    objFilter,
    blockTypeLinkTo,
    isVideoPop,
    videoNative,
    removeCIDUrl,
    isDeepLinkShareUrl,
    findCategoryTitleByKey,
} from '@src/utils/util';
import { withBasePath } from '@src/common/path-convert';
import { jsBridge } from '@src/utils/js-bridge';
import { useGlobalStore } from '@src/hooks/use-global-store';
import ImgLazy from '@components/img-lazy';
import isSharePageStore from '@mobx/stores/isShare-store';
import cn from 'classnames';
import kolLeaderRank from '@components/kolLeaderRank/kolLeaderRank';

type Props = {
    content: DiscoverMainContentFolderFragment;
    filterValue: string;
    kolRankData: KolSectionItemFragment | null;
    categoryData: CategoriesFragment[];
};
export default function BigSingle({ content, filterValue, kolRankData, categoryData }: Props) {
    const router = useRouter();
    const { t, i18n } = useTranslation();
    const newArr = contentArr(filterValue, content);
    const { settingStore } = useGlobalStore();
    const videoPopupStore = useGlobalStore().videoPopupStore;
    const isSharePage = isSharePageStore.isSharePage;
    const isEng = i18n.language == 'en-US';
    const isZHCN = content?.useSimplifiedChinese?.boolValue ?? false;

    return (
        <div className='py-[12px] big-single'>
            <div className='flex justify-between mb-[12px] px-[12px] items-baseline sm:pl-[24px]'>
                <div
                    className='text-[20px] max-w-[80%]'
                    dangerouslySetInnerHTML={{
                        __html: content?.sectionTitle?.value || '',
                    }}
                ></div>
                {newArr.length > 1 && (
                    <div
                        className='text-[13px] text-[#122C68]'
                        onClick={() => {
                            if (isSharePage) {
                                return;
                            }
                            router.push(removeCIDUrl(`${content.key}${location.search}`));
                        }}
                    >
                        {isZHCN ? '更多' : t('common:seeAll')}
                    </div>
                )}
            </div>
            <CategorySwiper
                options={{
                    autoHeight: true,
                    resizeObserver: true,
                    slidesPerView: 'auto',
                }}
                slideClassName='!w-[332px]'
                spaceBetween={8}
                swiperClassName='px-[12px] sm:px-[24px]'
            >
                {newArr.map((i: ContentBlockFragment) => {
                    const isDeepLink = i.blockType?.value === 'DeepLink';
                    const isKolLGRank =
                        i.key === 'kol-leaderboard' && kolRankData?.rankEnabled?.boolValue;
                    const categoryTitle =
                        (i?.category?.categories &&
                            i.category.categories.length > 0 &&
                            objFilter(i?.category?.categories)[0]?.categoryTitle?.value) ||
                        '';
                    const categoryName =
                        (i?.category?.categories &&
                            i.category.categories.length > 0 &&
                            objFilter(i?.category?.categories)[0]?.name) ||
                        '';
                    const categoryText = isZHCN
                        ? findCategoryTitleByKey(categoryName, categoryData)
                        : categoryTitle;

                    return (
                        <div key={i.key} className={cn(isSharePage && 'pointer-events-none')}>
                            {isDeepLink ? (
                                <div className='relative'>
                                    {i.shareIcon?.boolValue && (
                                        <img
                                            className='w-[24px] absolute top-[8px] right-[8px] z-10'
                                            src={withBasePath('/images/share_bg_bule.svg')}
                                            alt=''
                                            loading='lazy'
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                if (isDeepLink) {
                                                    return jsBridge.appShareUrl(
                                                        isDeepLinkShareUrl(i.deepLink?.value ?? ''),
                                                        i
                                                    );
                                                }

                                                const shareLink =
                                                    i.blockType?.value === 'Internal'
                                                        ? i.internalLink?.value ?? ''
                                                        : `${content?.key}/${i.key}/`;

                                                jsBridge.appShareUrl(
                                                    `${isShareUrl(
                                                        i.blockType?.value,
                                                        shareLink,
                                                        i.raceLink?.targetItem?.path
                                                    )}`,
                                                    i
                                                );
                                            }}
                                        />
                                    )}
                                    <a href={i.deepLink?.value ?? ''} target='_blank'>
                                        <div
                                            className={`relative bg-white rounded-[8px] overflow-hidden h-[253px]`}
                                        >
                                            {isKolLGRank ? (
                                                kolLeaderRank(kolRankData, isEng)
                                            ) : (
                                                <ImgLazy
                                                    height={174}
                                                    src={i?.heroImage?.src ?? ''}
                                                />
                                            )}

                                            {isTimeFrame(
                                                (i.isIconDisplay && i.isIconDisplay.boolValue) ||
                                                    false,
                                                i.iconDisplayStartDate?.dateValue || 0,
                                                i.iconDisplayEndDate?.dateValue || 0
                                            ) && (
                                                <img
                                                    src={i.iconDisplay?.targetItem?.iconImage?.src}
                                                    alt=''
                                                    loading='lazy'
                                                    className='h-[20px] absolute top-[12px] left-[12px]'
                                                ></img>
                                            )}

                                            <div className='text-black pl-[10px]'>
                                                <div
                                                    className='text-[#031E6C] text-[13px] mt-[8px] line-clamp-1 categoryBr min-h-[16.5px]'
                                                    dangerouslySetInnerHTML={{
                                                        __html: categoryText,
                                                    }}
                                                ></div>
                                                <div
                                                    className='text-[15px]  mb-[10px] line-clamp-2 h-[45px]'
                                                    style={{ wordBreak: 'break-word' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: i?.pageTitle?.value || '',
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ) : (
                                <div
                                    className={`relative bg-white rounded-[8px] overflow-hidden h-[253px] ${isVideoPop(
                                        i
                                    )}`}
                                    data-poster={i.videoLink?.value}
                                    data-image={i.videoPoster?.src}
                                    onClick={() => {
                                        videoNative(i, jsBridge);

                                        if (i.blockType?.value === 'Video') {
                                            return videoPopupStore.updateContentBlockData(i);
                                        }
                                        const generalLink = removeCIDUrl(
                                            `/${content.key}/${i.key}${location.search}`
                                        );

                                        blockTypeLinkTo(
                                            i,
                                            generalLink,
                                            router,
                                            jsBridge,
                                            settingStore
                                        );
                                    }}
                                >
                                    {isKolLGRank ? (
                                        kolLeaderRank(kolRankData, isEng)
                                    ) : (
                                        <ImgLazy height={174} src={i?.heroImage?.src ?? ''} />
                                    )}

                                    {i.shareIcon?.boolValue && (
                                        <img
                                            className='w-[24px] absolute top-[8px] right-[8px] z-10'
                                            src={withBasePath('/images/share_bg_bule.svg')}
                                            alt=''
                                            loading='lazy'
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                const shareLink =
                                                    i.blockType?.value === 'Internal'
                                                        ? i.internalLink?.value ?? ''
                                                        : `${content?.key}/${i.key}/`;

                                                jsBridge.appShareUrl(
                                                    `${isShareUrl(
                                                        i.blockType?.value,
                                                        shareLink,
                                                        i.raceLink?.targetItem?.path
                                                    )}`,
                                                    i
                                                );
                                            }}
                                        />
                                    )}
                                    {isTimeFrame(
                                        (i.isIconDisplay && i.isIconDisplay.boolValue) || false,
                                        i.iconDisplayStartDate?.dateValue || 0,
                                        i.iconDisplayEndDate?.dateValue || 0
                                    ) && (
                                        <img
                                            src={i.iconDisplay?.targetItem?.iconImage?.src}
                                            alt=''
                                            loading='lazy'
                                            className='h-[20px] absolute top-[12px] left-[12px]'
                                        ></img>
                                    )}

                                    <div className='text-black pl-[10px]'>
                                        <div
                                            className='text-[#031E6C] text-[13px] mt-[8px] line-clamp-1 categoryBr min-h-[16.5px]'
                                            dangerouslySetInnerHTML={{
                                                __html: categoryText,
                                            }}
                                        ></div>
                                        <div
                                            className='text-[15px]  mb-[10px] line-clamp-2 h-[45px]'
                                            style={{ wordBreak: 'break-word' }}
                                            dangerouslySetInnerHTML={{
                                                __html: i?.pageTitle?.value || '',
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </CategorySwiper>
        </div>
    );
}
